import { RequestOptions } from "axios-types";
import { ApiEndpoints } from "configs";
import { IGetDeviceHeartbeatQuery, IGetDeviceHeartbeatResponse } from "types/device";
import ExecuteAsync from "utils/api-client";
import createQueryParams from "utils/create-query-params";

export function executeGetLineChartDataRequest() {
    return ExecuteAsync({
        method: "GET",
        url: "/cyclewaysLocation/getLineChart",
    });
}

export function executeGetDeviceHeartbeatRequest(query: IGetDeviceHeartbeatQuery, options?: RequestOptions) {
    return ExecuteAsync<never, IGetDeviceHeartbeatResponse>({
        baseURL: ApiEndpoints.BaseUrlEndpoint,
        method: "GET",
        url: `/location/device/heartbeat/latest${createQueryParams(query)}`,
        signal: options?.signal,
    });
}
